export enum EZipProductCode {
  ZipMoney = 'ZipMoney',
  ZipPay = 'ZipPay',
}

export interface UserInfo {
  id?: string;
  accounts?: [
    {
      accountId: string;
      accountStatus: string;
      productCode: EZipProductCode;
    },
  ];
}
